// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".services-table__billing-info[data-v-90d80214]{display:grid;grid-template-columns:1fr 1.1fr;gap:8px}.services-table__tags-container[data-v-90d80214]{display:flex;flex-wrap:wrap;gap:6px;margin-top:4px}.services-table__tag[data-v-90d80214]{width:-moz-fit-content;width:fit-content;padding:3px 5px;line-height:1;background-color:#ffa43c;border-radius:3px;font-size:11px;color:#fff}", ""]);
// Exports
module.exports = exports;
